<template>
	<section class="newsletter-section">
		<div class="row">
			<div class="columns column6">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
			</div>
			<div class="columns column6">
				<form class="newsletter">
					<input type="text" class="email" :placeholder="$t('formEmail')" />
					<input type="submit" class="button" :value="button" />
				</form>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter-section {
	padding: 60px 0;
	margin: 0;
	background: var(--secondary-background-color);
	border-bottom: none;

	.row {
		border: 10px solid var(--cta-color);
		padding: 60px 40px;
	}

	h2,
	h3 {
		margin: 0 0 20px;

		&::after {
			display: none;
		}
	}

	form {
		margin-top: 30px;
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		justify-content: center;
		gap: 10px;

		input {
			background: var(--primary-background-color);
			font-family: var(--body-font-family);
			padding: 15px;
			height: 52px;
			border: none;
			width: 48%;
			max-width: 300px;
			vertical-align: top;
			font-weight: 700;
			font-size: 18px;

			&::placeholder {
				color: #333;
			}

			&.email {
				background: url('~/assets/images/email-bg-icon.png') no-repeat center right 10px #fff;
				background-size: 19px;
				padding-right: 30px;
			}

			&.button {
				line-height: 22px;
				margin: 0;
				width: auto;
				padding: 14px 30px;
				background: var(--cta-color);
				color: #fff;
				max-width: 200px;
				font-size: 13px;

				&:hover {
					background: var(--cta-color-hover);
					color: #fff;
				}
			}
		}
	}
}
</style>
